/* eslint-disable max-classes-per-file */
import { Action } from '@ngrx/store';
import { Credentials } from './login.model';
import { TwoFACode } from '@app/auth/core/state/auth.model';

export enum ActionTypes {
  LOGIN = '[Auth] Login',
  LOGIN_SUCCESS = '[Auth] Login Success',
  LOGIN_FAILURE = '[Auth] Login Failure',
  LOGIN_CHECK_EMAIL_DOMAIN = '[Auth] Login check SSO',
  LOGIN_SHOW_PASSWORD = '[Auth] Login show password',
  LOGIN_TO_AZURE_AD_SUCCESS = '[Auth] Login to azure ad success',

  VERIFY_2FA_CODE = '[Auth] Verify 2FA Code',
  VERIFY_2FA_VIA_RECOVERY_CODE = '[Auth] Verify 2FA Via Recovery Code',
  VERIFY_2FA_CODE_FAILURE = '[Auth] Verify 2FA Code or Backup Failure',
}

// todo: rewrite to new Actions approach and back code from new.login.actions.ts
export class Login implements Action {
  public readonly type = ActionTypes.LOGIN;

  constructor(public payload: Credentials) {}
}

export class LoginSuccess implements Action {
  public readonly type = ActionTypes.LOGIN_SUCCESS;
}

export class LoginFailure implements Action {
  public readonly type = ActionTypes.LOGIN_FAILURE;

  constructor(
    public payload: {
      error: string;
      attemptsLeft?: number;
      bannedTime?: number;
    },
  ) {}
}

export class LoginVerify2FACode implements Action {
  public readonly type = ActionTypes.VERIFY_2FA_CODE;

  constructor(public payload: TwoFACode) {}
}

export class LoginVerify2FACodeFailure implements Action {
  public readonly type = ActionTypes.VERIFY_2FA_CODE_FAILURE;

  constructor(
    public payload:
      | { code: string }
      | {
          attemptsLeft: number;
          banned: number;
          message: string;
        },
  ) {}
}

export class LoginShowPassword implements Action {
  public readonly type = ActionTypes.LOGIN_SHOW_PASSWORD;
}

export class LoginToAzureADSuccess implements Action {
  public readonly type = ActionTypes.LOGIN_TO_AZURE_AD_SUCCESS;
}

export class LoginCheckEmailDomain implements Action {
  public readonly type = ActionTypes.LOGIN_CHECK_EMAIL_DOMAIN;

  constructor(public payload: string) {}
}

export type Actions =
  | Login
  | LoginSuccess
  | LoginFailure
  | LoginVerify2FACode
  | LoginVerify2FACodeFailure
  | LoginCheckEmailDomain
  | LoginShowPassword
  | LoginToAzureADSuccess;
